export default __webpack_public_path__ + "static/media/interview.2098f62a.svg";